import React, { type ReactElement } from 'react';
import { faCircleDown, faCircleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'atom-components/card';
import styles from './chart-legend.module.scss';

type Props = { minPercentageCorrect: number };

export default function ChartLegend(props: Props): ReactElement {
  const { minPercentageCorrect } = props;

  return (
    <Card className={styles.chartLegend}>
      <Card.Header>
        <Card.Heading level={3}>Legend / Key</Card.Heading>
      </Card.Header>

      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <div className={styles.icon}>
            <FontAwesomeIcon
              icon={faCircleUp}
              color="green"
              title="green circle with a white up arrow"
            />
          </div>
          <div>
            <span className="fw-bold">&gt;= {minPercentageCorrect}%</span> of responses are{' '}
            <b>correct</b>.
          </div>
        </li>
        <li className="list-group-item">
          <div className={styles.icon}>
            <FontAwesomeIcon
              icon={faCircleDown}
              color="red"
              title="red circle with a white down arrow"
            />
          </div>
          <div>
            <span className="fw-bold">&gt; {minPercentageCorrect}%</span> of responses are{' '}
            <b>incorrect</b>.
          </div>
        </li>
      </ul>
    </Card>
  );
}
